/* Repository path: frontend/src/utils/productName.ts */

/**
 * W6-02 (D-W6-02-03, founder-signed in docs/product/W6-02_FOUNDER_ACCEPTANCE.md §6 C-01):
 * the product's one on-screen name. The top bar, its home-link label, every route title
 * that names the product, the support prompt and the feedback panel all read this
 * constant, so a later rename is a one-line change.
 *
 * `index.html` cannot import a module, so its `<title>` repeats the literal;
 * `src/app/productName.test.ts` fails if the two ever differ.
 *
 * The welcome eyebrow "Dutch financial check" is a description, not the name, and is
 * deliberately not routed through this constant.
 */
export const PRODUCT_NAME = "Blauwe";
